export default "__VITE_ASSET__QGsIyV7c__"